/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.171.0-v202607242315-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqConditionsApiClass {
 
   constructor() {}

  /**
   * @summary Add capsules to a stored condition
   * @param {string} id - ID of the stored condition that will receive the capsules
  */
  public addCapsules(
    body: models.CapsulesInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions/${encodeURIComponent(String(id))}/capsules`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Archive a condition and its capsules
   * @param {string} id - ID of the condition to archive
  */
  public archiveCondition(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a condition
  */
  public createCondition(
    body: models.ConditionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ConditionOutputV1>;
  }

  /**
   * @summary Delete all capsules in a condition
   * @param {string} id - The Seeq ID for the signal
   * @param {boolean} [clearCapsuleProperties=false] - When true, clears capsule property definitions from the condition after deleting the capsules.
  */
  public deleteCapsules(
    {
      id,
      clearCapsuleProperties
    } : {
      id: string,
      clearCapsuleProperties?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions/${encodeURIComponent(String(id))}/capsules`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['clearCapsuleProperties']: clearCapsuleProperties
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Delete capsules in a time range from a condition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the condition
   * @param {string} start - ISO 8601 timestamp. When exactMatch&#x3D;false (default): start of the time range (inclusive), deletes capsules with start time &gt;&#x3D; this value. When exactMatch&#x3D;true: the exact start time of the capsule to delete (both start and end must match exactly).
   * @param {string} end - ISO 8601 timestamp. When exactMatch&#x3D;false (default): end of the time range (exclusive), deletes capsules with start time &lt; this value. When exactMatch&#x3D;true: the exact end time of the capsule to delete (both start and end must match exactly).
   * @param {boolean} [exactMatch] - If true, only delete capsules that exactly match both the provided start and end times (i.e., capsule.start &#x3D;&#x3D; start AND capsule.end &#x3D;&#x3D; end). If false (default), deletes all capsules whose start time falls within the half-open range [start, end). Use exactMatch&#x3D;true to target a specific capsule and avoid collateral deletion of overlapping capsules.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public deleteCapsulesByRange(
    {
      id,
      start,
      end,
      exactMatch
    } : {
      id: string,
      start: string,
      end: string,
      exactMatch?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (start === null || start === undefined) {
      throw new Error("'start' parameter required");
    }

    if (end === null || end === undefined) {
      throw new Error("'end' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions/${encodeURIComponent(String(id))}/capsules/range`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['start']: start,      ['end']: end,      ['exactMatch']: exactMatch
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get capsules from a condition
   * @param {string} id - ID of the condition from which to retrieve capsules
   * @param {string} start - A string representing the start of the range of the capsules to be returned. The contents vary based on the condition type. For time conditions: a ISO 8601 timestamp (YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm).
   * @param {string} end - A string representing the end of the range of the capsules to be returned. The contents vary based on the condition type. For time conditions: a ISO 8601 timestamp (YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm).
   * @param {string} [unitOfMeasure] - The unit of measure in which to return the condition&#x27;s capsules&#x27; starts and ends. If none is supplied, the data is returned in the condition&#x27;s default unit of measure.
   * @param {string} [timeFormat=ISO8601] - The timestamp format.
   * @param {number} [limit=1000] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {string} [continuationToken] - An opaque token used to query for the next page of results. Only use if returned by a previous call.
  */
  public getCapsules(
    {
      id,
      start,
      end,
      unitOfMeasure,
      timeFormat,
      limit,
      continuationToken
    } : {
      id: string,
      start: string,
      end: string,
      unitOfMeasure?: string,
      timeFormat?: GetCapsulesTimeFormatEnum,
      limit?: number,
      continuationToken?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (start === null || start === undefined) {
      throw new Error("'start' parameter required");
    }

    if (end === null || end === undefined) {
      throw new Error("'end' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions/${encodeURIComponent(String(id))}/capsules`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['start']: start,      ['end']: end,      ['unitOfMeasure']: unitOfMeasure,      ['timeFormat']: timeFormat,      ['limit']: limit,      ['continuationToken']: continuationToken
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.CapsulesOutputV1>;
  }

  /**
   * @summary Get a condition
   * @param {string} id - ID of the condition to retrieve
  */
  public getCondition(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ConditionOutputV1>;
  }

  /**
   * @summary Get a collection of conditions
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getConditions(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Replace any capsules in the same time range
   * @param {string} id - ID of the stored condition that will receive the capsules
  */
  public putCapsules(
    body: models.CapsulesOverwriteInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions/${encodeURIComponent(String(id))}/capsules`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'put',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Create or update multiple conditions
  */
  public putConditions(
    body?: models.ConditionBatchInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions/batch`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemBatchOutputV1>;
  }

  /**
   * @summary Update an existing condition
   * @param {string} id - The id for the condition to be updated
  */
  public updateExistingCondition(
    body: models.ConditionUpdateInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/conditions/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ConditionOutputV1>;
  }

}

export const GetCapsulesTimeFormatEnum = {
    Legacy: 'Legacy',
    ISO8601: 'ISO8601',
    Nanoseconds: 'Nanoseconds'
} as const;

export type GetCapsulesTimeFormatEnum = typeof GetCapsulesTimeFormatEnum[keyof typeof GetCapsulesTimeFormatEnum];

export const sqConditionsApi = new sqConditionsApiClass();

export type sqConditionsApiEndpoints = {
  'addCapsules': {
    method: 'post';
    path: '/conditions/${encodeURIComponent(String(id))}/capsules';
    response: models.StatusMessageBase;
  };
  'archiveCondition': {
    method: 'delete';
    path: '/conditions/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'createCondition': {
    method: 'post';
    path: '/conditions';
    response: models.ConditionOutputV1;
  };
  'deleteCapsules': {
    method: 'delete';
    path: '/conditions/${encodeURIComponent(String(id))}/capsules';
    response: models.StatusMessageBase;
  };
  'deleteCapsulesByRange': {
    method: 'delete';
    path: '/conditions/${encodeURIComponent(String(id))}/capsules/range';
    response: models.StatusMessageBase;
  };
  'getCapsules': {
    method: 'get';
    path: '/conditions/${encodeURIComponent(String(id))}/capsules';
    response: models.CapsulesOutputV1;
  };
  'getCondition': {
    method: 'get';
    path: '/conditions/${encodeURIComponent(String(id))}';
    response: models.ConditionOutputV1;
  };
  'getConditions': {
    method: 'get';
    path: '/conditions';
    response: models.ItemPreviewListV1;
  };
  'putCapsules': {
    method: 'put';
    path: '/conditions/${encodeURIComponent(String(id))}/capsules';
    response: models.StatusMessageBase;
  };
  'putConditions': {
    method: 'post';
    path: '/conditions/batch';
    response: models.ItemBatchOutputV1;
  };
  'updateExistingCondition': {
    method: 'post';
    path: '/conditions/${encodeURIComponent(String(id))}';
    response: models.ConditionOutputV1;
  };
};

type ApiAddCapsulesResponse = models.StatusMessageBase;
type ApiaddCapsulesMutationParams = Parameters<typeof sqConditionsApi.addCapsules> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionsApi.addCapsules>;

export function useApiAddCapsulesMutation(
  options?: Omit<UseMutationOptions<ApiAddCapsulesResponse, AxiosError<SeeqErrorData>,
    ApiaddCapsulesMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiAddCapsulesResponse, AxiosError<SeeqErrorData>,
  ApiaddCapsulesMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiaddCapsulesMutationParams) =>
      sqConditionsApi.addCapsules(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveConditionResponse = models.ArchiveOutputV1;
type ApiarchiveConditionMutationParams = Parameters<typeof sqConditionsApi.archiveCondition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionsApi.archiveCondition>;

export function useApiArchiveConditionMutation(
  options?: Omit<UseMutationOptions<ApiArchiveConditionResponse, AxiosError<SeeqErrorData>,
    ApiarchiveConditionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveConditionResponse, AxiosError<SeeqErrorData>,
  ApiarchiveConditionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveConditionMutationParams) =>
      sqConditionsApi.archiveCondition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateConditionResponse = models.ConditionOutputV1;
type ApicreateConditionMutationParams = Parameters<typeof sqConditionsApi.createCondition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionsApi.createCondition>;
type ApicreateConditionMutationVariables = models.ConditionInputV1;

export function useApiCreateConditionMutation(
  options?: Omit<UseMutationOptions<ApiCreateConditionResponse, AxiosError<SeeqErrorData>,
    ApicreateConditionMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateConditionResponse, AxiosError<SeeqErrorData>,
  ApicreateConditionMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateConditionMutationVariables) =>
      sqConditionsApi.createCondition(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteCapsulesResponse = models.StatusMessageBase;
type ApideleteCapsulesMutationParams = Parameters<typeof sqConditionsApi.deleteCapsules> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionsApi.deleteCapsules>;

export function useApiDeleteCapsulesMutation(
  options?: Omit<UseMutationOptions<ApiDeleteCapsulesResponse, AxiosError<SeeqErrorData>,
    ApideleteCapsulesMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteCapsulesResponse, AxiosError<SeeqErrorData>,
  ApideleteCapsulesMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteCapsulesMutationParams) =>
      sqConditionsApi.deleteCapsules(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteCapsulesByRangeResponse = models.StatusMessageBase;
type ApideleteCapsulesByRangeMutationParams = Parameters<typeof sqConditionsApi.deleteCapsulesByRange> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionsApi.deleteCapsulesByRange>;

export function useApiDeleteCapsulesByRangeMutation(
  options?: Omit<UseMutationOptions<ApiDeleteCapsulesByRangeResponse, AxiosError<SeeqErrorData>,
    ApideleteCapsulesByRangeMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteCapsulesByRangeResponse, AxiosError<SeeqErrorData>,
  ApideleteCapsulesByRangeMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteCapsulesByRangeMutationParams) =>
      sqConditionsApi.deleteCapsulesByRange(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetCapsulesResponse = models.CapsulesOutputV1;
export function GetCapsulesQueryKey(
  params: Parameters<typeof sqConditionsApi.getCapsules>[0],
) {
  return ['sqConditionsApi', 'getCapsules', params] as const;
}

export function useApiGetCapsulesQuery(
  params: Parameters<typeof sqConditionsApi.getCapsules>[0],
  options?: Omit<UseQueryOptions<ApiGetCapsulesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetCapsulesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetCapsulesQueryKey(params),
    queryFn: () =>
      sqConditionsApi.getCapsules(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConditionResponse = models.ConditionOutputV1;
export function GetConditionQueryKey(
  params: Parameters<typeof sqConditionsApi.getCondition>[0],
) {
  return ['sqConditionsApi', 'getCondition', params] as const;
}

export function useApiGetConditionQuery(
  params: Parameters<typeof sqConditionsApi.getCondition>[0],
  options?: Omit<UseQueryOptions<ApiGetConditionResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetConditionResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetConditionQueryKey(params),
    queryFn: () =>
      sqConditionsApi.getCondition(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConditionsResponse = models.ItemPreviewListV1;
export function GetConditionsQueryKey(
  params: Parameters<typeof sqConditionsApi.getConditions>[0],
) {
  return ['sqConditionsApi', 'getConditions', params] as const;
}

export function useApiGetConditionsQuery(
  params: Parameters<typeof sqConditionsApi.getConditions>[0],
  options?: Omit<UseQueryOptions<ApiGetConditionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetConditionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetConditionsQueryKey(params),
    queryFn: () =>
      sqConditionsApi.getConditions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPutCapsulesResponse = models.StatusMessageBase;
type ApiputCapsulesMutationParams = Parameters<typeof sqConditionsApi.putCapsules> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionsApi.putCapsules>;

export function useApiPutCapsulesMutation(
  options?: Omit<UseMutationOptions<ApiPutCapsulesResponse, AxiosError<SeeqErrorData>,
    ApiputCapsulesMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPutCapsulesResponse, AxiosError<SeeqErrorData>,
  ApiputCapsulesMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiputCapsulesMutationParams) =>
      sqConditionsApi.putCapsules(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPutConditionsResponse = models.ItemBatchOutputV1;
type ApiputConditionsMutationParams = Parameters<typeof sqConditionsApi.putConditions> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionsApi.putConditions>;
type ApiputConditionsMutationVariables = models.ConditionBatchInputV1 | undefined;

export function useApiPutConditionsMutation(
  options?: Omit<UseMutationOptions<ApiPutConditionsResponse, AxiosError<SeeqErrorData>,
    ApiputConditionsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPutConditionsResponse, AxiosError<SeeqErrorData>,
  ApiputConditionsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApiputConditionsMutationVariables) =>
      sqConditionsApi.putConditions(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiUpdateExistingConditionResponse = models.ConditionOutputV1;
type ApiupdateExistingConditionMutationParams = Parameters<typeof sqConditionsApi.updateExistingCondition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionsApi.updateExistingCondition>;

export function useApiUpdateExistingConditionMutation(
  options?: Omit<UseMutationOptions<ApiUpdateExistingConditionResponse, AxiosError<SeeqErrorData>,
    ApiupdateExistingConditionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateExistingConditionResponse, AxiosError<SeeqErrorData>,
  ApiupdateExistingConditionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateExistingConditionMutationParams) =>
      sqConditionsApi.updateExistingCondition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
